<template>
  <section class="dash-section" aria-labelledby="dash-insights-heading">
    <div class="dash-section__head">
      <div>
        <h2 id="dash-insights-heading" class="dash-section__title">AI Performance Insights</h2>
        <p class="dash-section__subtitle">Intelligent analysis of your call agent activity</p>
      </div>
    </div>

    <div class="dash-insights">
      <div class="dash-insights__score">
        <div
          class="dash-score-ring"
          :class="{ 'dash-score-ring--empty': insights.score == null }"
          :style="{ '--dash-score': insights.score ?? 0 }"
        >
          <svg viewBox="0 0 120 120" class="dash-score-ring__svg" aria-hidden="true">
            <circle cx="60" cy="60" r="52" class="dash-score-ring__track" />
            <circle cx="60" cy="60" r="52" class="dash-score-ring__progress" />
          </svg>
          <div class="dash-score-ring__label">
            <span class="dash-score-ring__value">{{ insights.score ?? '—' }}</span>
            <span class="dash-score-ring__text">AI Score</span>
          </div>
        </div>
        <p v-if="insights.score == null" class="dash-insights__score-hint">
          No calls yet this period
        </p>
        <p v-else class="dash-insights__score-hint">
          Share of calls not flagged for review
        </p>
      </div>

      <div class="dash-insights__grid" role="list">
        <div class="dash-insight-item" role="listitem">
          <v-icon icon="mdi-calendar-star" size="20" class="dash-insight-item__icon" />
          <div>
            <span class="dash-insight-item__label">Peak Call Day</span>
            <span class="dash-insight-item__value">{{ insights.peakDay }}</span>
          </div>
        </div>
        <div class="dash-insight-item" role="listitem">
          <v-icon icon="mdi-clock-outline" size="20" class="dash-insight-item__icon" />
          <div>
            <span class="dash-insight-item__label">Peak Call Hour</span>
            <span class="dash-insight-item__value">{{ insights.peakHour }}</span>
          </div>
        </div>
        <div class="dash-insight-item" role="listitem">
          <v-icon icon="mdi-chart-bell-curve" size="20" class="dash-insight-item__icon" />
          <div>
            <span class="dash-insight-item__label">Most Active Period</span>
            <span class="dash-insight-item__value">{{ insights.activePeriod }}</span>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script setup>
defineOptions({ name: 'DashboardInsightsPanel' })

defineProps({
  insights: {
    type: Object,
    default: () => ({
      score: null,
      peakDay: '—',
      peakHour: 'No calls yet',
      activePeriod: '—',
    }),
  },
})
</script>
